module.exports = __webpack_public_path__ + "static/media/agenda.0b84a1f5.svg";